import { computed } from 'vue';
import { useStore } from 'dashboard/composables/store.js';
import { useAccount } from 'dashboard/composables/useAccount';
import { useConfig } from 'dashboard/composables/useConfig';
import { useCamelCase } from 'dashboard/composables/useTransformKeys';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

export function useAilab() {
  const store = useStore();
  const { isCloudFeatureEnabled, currentAccount } = useAccount();
  const { isEnterprise } = useConfig();

  const ailabEnabled = computed(() => {
    return isCloudFeatureEnabled(FEATURE_FLAGS.CAPTAIN);
  });

  const ailabLimits = computed(() => {
    return currentAccount.value?.limits?.captain;
  });

  const documentLimits = computed(() => {
    if (ailabLimits.value?.documents) {
      return useCamelCase(ailabLimits.value.documents);
    }

    return null;
  });

  const responseLimits = computed(() => {
    if (ailabLimits.value?.responses) {
      return useCamelCase(ailabLimits.value.responses);
    }

    return null;
  });

  const fetchLimits = () => {
    if (isEnterprise) {
      store.dispatch('accounts/limits');
    }
  };

  return {
    ailabEnabled,
    ailabLimits,
    documentLimits,
    responseLimits,
    fetchLimits,
  };
}
